import React, { Component } from "react";
import { uniq, map, flatten } from "lodash";
import moment from "moment";
import { Series } from "@amcharts/amcharts4/charts";

class Format extends Component {
  static Countries(devices) {
    return uniq(map(devices, "country")).sort();
  }
  static Customers(devices, country) {
    if (country === null || country === "all") return uniq(map(devices, "customerName")).sort();
    return uniq(
      map(
        devices.filter((obj) => obj.country === country),
        "customerName"
      )
    ).sort();
  }

  static CountryByDeviceWithSerial(devices,deviceWithSerial){
    if (deviceWithSerial == null) return null;
    const country = uniq(
      map(
        devices.filter((obj) => obj.deviceWithSerial === deviceWithSerial),
        "country"
      )
    )
    if (country.length == 1){
      return country[0]
    }
    return null;
  }

  static countryByCADID(devices,cadid){
    if (cadid == null) return null;
    const country = uniq(
      map(
        devices.filter((obj) => obj.customerAssemblyDeviceID === cadid),
        "country"
      )
    )
    if (country.length == 1){
      return country[0]
    }
    return null;
  }

  static countryByCustomerName(devices,customerName){
    if (customerName == null) return null;
    const country = uniq(
      map(
        devices.filter((obj) => obj.customerName === customerName),
        "country"
      )
    )
    if (country.length == 1){
      return country[0]
    }
    return null;
  }

  static Machines(devices, country, customer) {
    if (country == null && customer == null)
      return uniq(map(devices, "mainMachineSerialNo")).sort();
    if (customer == null) {
      return uniq(
        map(
          devices.filter((obj) => obj.country === country),
          "mainMachineSerialNo"
        )
      ).sort();
    } else if (country == null) {
      return uniq(
        map(
          devices.filter((obj) => obj.customerName === customer),
          "mainMachineSerialNo"
        )
      ).sort();
    } else {
      return uniq(
        map(
          devices.filter(
            (obj) => obj.customerName === customer && obj.country == country
          ),
          "mainMachineSerialNo"
        )
      ).sort();
    }
  }

  static customerByCustomerID(devices,customerID){
    if (customerID == null) return null;
    const customer = uniq(
      map(
        devices.filter((obj) => obj.customerID === customerID),
        "customerName"
      )
    )
    if (customer.length == 1){
      return customer[0]
    }
    return null;
  }

  static CustomerByCadID(devices, cadid){
    if (cadid == null) return null;
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].customerAssemblyDeviceID == cadid) {
        return devices[i].customerName;
      }
    }
  }

  static CustomerByDeviceWithSerial(devices,deviceWithSerial){
    if (deviceWithSerial == null) return null;
    const customer = uniq(
      map(
        devices.filter((obj) => obj.deviceWithSerial === deviceWithSerial),
        "customerName"
      )
    )
    if (customer.length == 1){
      return customer[0]
    }
    return null;
  }

  static customerIDByDeviceWithSerial(devices,devicesWithSerial){
    const obj = devices.find(o => o.deviceWithSerial === devicesWithSerial);
    if (obj){
        return obj.customerID;
    }
    return null;
  }
    static customerIDByCustomerName(devices, customerName) {
        const obj = devices.find(o => o.customerName === customerName);
        if (obj) {
            return obj.customerID;
        }
        return null;
    }
  
  static customersByDeviceTypeAndCountry(devices,devicetypes,country){
    let customers = []
    //
    if (country === null || country === "all"){
      if (devicetypes.length === 0){
        customers = uniq(
          map(
            devices.filter(obj=>obj.customerName),"customerName"
          )
        ).sort()
      }else{
        customers = uniq(
          map(
            devices.filter((obj) => devicetypes.includes(obj.deviceFull)),"customerName"
          )
        ).sort()
      }
    }else{
      if (devicetypes.length === 0){
        customers = uniq(
          map(
            devices.filter(obj=> obj.country === country),"customerName"
          )
        ).sort()
      }else{
        customers = uniq(
          map(
            devices.filter((obj) => devicetypes.includes(obj.deviceFull) && obj.country === country),"customerName"
          )
        ).sort()
      }
    }
    return customers
  }

  static DeviceWithSerialObjects(devices, customer) {
    let DevicesWithSerial = []
    if (customer == null){
      DevicesWithSerial = uniq(
        map(
          devices.filter(obj=>obj.customerName),
          "deviceWithSerial"
        )
      ).sort();
    }else{
      DevicesWithSerial = uniq(
        map(
          devices.filter((obj) => obj.customerName === customer),
          "deviceWithSerial"
        )
      ).sort();
    }
    const arrayOfObjects = []
    DevicesWithSerial.forEach((deviceWithSerial,i)=>{
        arrayOfObjects.push({text:deviceWithSerial,id:i})
    })
    return arrayOfObjects;
  }

  static DeviceWithSerialObjectsByDevice(DevicesWithSerial) {
    if (DevicesWithSerial.length === 0 ) return [];
    const arrayOfObjects = []
    DevicesWithSerial.forEach((deviceWithSerial,i)=>{
        arrayOfObjects.push({text:deviceWithSerial})
    })
    return arrayOfObjects;
  }

  static DevicesWithSerial(devices, customer) {
    
    let devicesWithSerial = [];
    if (customer == null){
      devicesWithSerial = uniq(
        map(
          devices.filter((obj) => obj.customerName),
          "deviceWithSerial"
        )
      ).sort();
    }else{
      devicesWithSerial = uniq(
        map(
          devices.filter((obj) => obj.customerName === customer),
          "deviceWithSerial"
        )
      ).sort();
    }
    return devicesWithSerial
  }

  static DeviceIDsByDeviceType(devices,devicetypes){
    if (devicetypes.length == 0) return []
    return uniq(
      map(
        devices.filter((obj) => devicetypes.includes(obj.deviceFull)),
        "deviceID"
        )
    ).sort();
  }

  static DeviceTypeStringsByObjects(deviceTypeObjects){
    const arr = []
    deviceTypeObjects.forEach(obj => { arr.push(obj.text)})
    return arr
  }

  static DeviceTypesByDeviceIDs(devices,deviceIDs){
    if (deviceIDs.length == 0) return []
    return uniq(
      map(
        devices.filter((obj) => deviceIDs.includes(obj.deviceID)),
        "deviceFull"
        )
    ).sort();
  }
  static DevicesBySelectedTypes(devices, deviceTypes, customer) {
    let DevicesWithSerial = []
    if (deviceTypes.length === 0){
      DevicesWithSerial = uniq(
        map(
          devices.filter(obj=>obj.customerName === customer),
          "deviceWithSerial"
          )
      ).sort();
    }else{
      DevicesWithSerial = uniq(
        map(
          devices.filter((obj) => deviceTypes.includes(obj.deviceFull)&&obj.customerName===customer),
          "deviceWithSerial"
          )
      ).sort();
    }
    //
    return DevicesWithSerial
    // const arrayOfObjects = []
    // DevicesWithSerial.forEach((deviceWithSerial,i)=>{
    //     arrayOfObjects.push({text:deviceWithSerial,id:i})
    // })
    // return arrayOfObjects;
  }

  static DeviceTypesByCustomer(devices, customer){
    if (customer == null){
      return uniq(map(
        devices.filter((obj)=>obj.customerName),
        "deviceFull"
      ))
    }else{
      return uniq(map(
        devices.filter((obj)=>obj.customerName===customer),
        "deviceFull"
      ))
    }
  }

  static DeviceTypesByCountry(devices, country) {
    let devicetypes = []
    if (country == null || country === "all"){
      devicetypes = uniq(
        map(
          devices.filter((obj) => obj.country),
          "deviceFull"
        )
      ).sort();
    }else{
      devicetypes = uniq(
        map(
          devices.filter((obj) => obj.country === country),
          "deviceFull"
        )
      ).sort();
    } 
    return devicetypes
  }

  static DeviceTypeObjects(devices){
    if (devices == null) return [];
    const deviceTypes = uniq(
      map(devices,"deviceFull")).sort();
    const arrayOfObjects = []
    deviceTypes.forEach((deviceType,i)=>{
        arrayOfObjects.push({text:deviceType,id:i})
    })
    return arrayOfObjects;
  }

  static DeviceTypeObjectsByCustomerAndCountry(devices,customer,country){
    if (customer === null){
      return this.DeviceTypeObjectsByCountry(devices,country)
    }else{
      return this.DeviceTypeObjectsByCustomer(devices,customer)
    }
  }

  static DeviceTypeObjectsByDeviceType(deviceTypes){
    if (deviceTypes.length === 0) return [];
    const arrayOfObjects = []
    deviceTypes.forEach((deviceType,i)=>{
        arrayOfObjects.push({text:deviceType,id:i})
    })
    return arrayOfObjects;
  }

  static DeviceTypeObjectsByCountry(devices,country){
    let deviceTypes = []
    if (country == null){
      deviceTypes = uniq(
        map(        
          devices.filter(obj => obj.country),
          "deviceFull")).sort();
    }else{
      deviceTypes = uniq(
        map(        
          devices.filter((obj) => obj.country === country),
          "deviceFull")).sort();
    }

    const arrayOfObjects = []
    deviceTypes.forEach((deviceType,i)=>{
        arrayOfObjects.push({text:deviceType,id:i})
    })
    return arrayOfObjects;
  }

  static DeviceTypeObjectsByCustomer(devices,customer){
    let deviceTypes = []
    if (customer == null){
      deviceTypes = uniq(
        map(        
          devices.filter((obj) => obj.customerName),
          "deviceFull")).sort();
    }else{
      deviceTypes = uniq(
        map(        
          devices.filter((obj) => obj.customerName === customer),
          "deviceFull")).sort();
    }        
    const arrayOfObjects = []
    deviceTypes.forEach((deviceType,i)=>{
        arrayOfObjects.push({text:deviceType,id:i})
    })
    return arrayOfObjects;
  }

  static DeviceTypes(devices, deviceType) {
    if (deviceType == "Device Name") {
      return uniq(map(devices, "deviceName")).sort();
    } else if (deviceType == "Device Name + Version") {
      return uniq(map(devices, "deviceNameVersion")).sort();
    } else if (deviceType == "Device Name + Device Size + Version") {
      return uniq(map(devices, "deviceFull")).sort();
    }
    return [];
    //return uniq(
    //    map(
    //        devices.filter((obj) => obj.customerName === customer),
    //        "deviceLabel"
    //    )
    //).sort();
  }
  
  static findDeviceName(devices, deviceWithSerial, seriesType) {
    for (var i = 0; i < devices.length; i++) {
      if (devices[i].deviceWithSerial == deviceWithSerial) {
        if (seriesType == "Device Name") {
          return devices[i].deviceName;
        } else if (seriesType == "Device Name + Device Size + Version") {
          return devices[i].deviceFull;
        }
      }
    }
  }
  static GetHeaderUnit(header, headers) {
    for (var i = 0; i < headers.length; i++) {
      if (headers[i].description == header) {
        if (header.includes("temperature")) return "deg";
        return headers[i].unit;
      }
    }

    return "";
  }
  static seriesParameters(devices, label, seriesType) {
    if (seriesType == "Device Name") {
      var obj = {};
      obj.versionNumber = "";
      obj.deviceSize = "";
      obj.deviceName = label;
      obj.customerAssemblyDeviceID = "";
      obj.name = label;
      return obj;
    } else if (seriesType == "Device Name + Version") {
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].deviceNameVersion == label) {
          var obj = {};
          obj.versionNumber = devices[i].versionNumber;
          obj.deviceSize = "";
          obj.deviceName = devices[i].deviceName;
          obj.customerAssemblyDeviceID = "";
          obj.name = label;
          return obj;
        }
      }
    } else if (seriesType == "Device Name + Device Size + Version") {
      
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].deviceFull == label) {
          var obj = {};
          obj.versionNumber = devices[i].versionNumber;
          obj.deviceSize = devices[i].deviceSize;
          obj.deviceName = devices[i].deviceName;
          obj.customerAssemblyDeviceID = "";
          obj.name = label;
          return obj;
        }
      }
    } else {
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].deviceLabel == label) {
          var obj = {};
          obj.versionNumber = "";
          obj.deviceSize = "";
          obj.deviceName = "";
          obj.name = label;
          obj.customerAssemblyDeviceID = devices[i].customerAssemblyDeviceID;
          return obj;
        }
      }
    }
  }

  static DeviceWithSerialByCADID(devices,cadid){
    if (cadid == null) return [];
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].customerAssemblyDeviceID == cadid) {
        return [devices[i].deviceWithSerial];
      }
    }
    return [];
  }

  static GetDeviceByCADID(devices, cadid) {
    if (cadid == null) return null;
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].customerAssemblyDeviceID == cadid) {
        return devices[i];
      }
    }
  }

  static DeviceObjs(devices, machine) {
    if (machine == null) return [];
    return devices.filter((obj) => obj.mainMachineSerialNo === machine);
  }
  
  static getDeviceItemsByLabel(devices, mainMachineSerialNo, deviceLabel) {
    const deviceItems = [];
    const getItems = (dl) => {
        for (let i = 0; i < devices.length; i++) {
            if (dl == null) {
                if (
                    devices[i].mainMachineSerialNo == mainMachineSerialNo 
                ) {
                    deviceItems.push({
                        text: devices[i].deviceFull,
                        id: devices[i].customerAssemblyDeviceID,
                    });
                }
            }
            else {
                if (
                    devices[i].mainMachineSerialNo == mainMachineSerialNo &&
                    devices[i].deviceFull == dl
                ) {
                    deviceItems.push({
                        text: devices[i].deviceFull,
                        id: devices[i].customerAssemblyDeviceID,
                    });
                }
            }
        
      }
    };
    if (Array.isArray(deviceLabel)) {
      deviceLabel.forEach((label) => {
        getItems(label);
      });
    }
    else {
      getItems(deviceLabel);
    }
    return deviceItems;
    } static DevicesWithSerialByCadids(devices, cadids) {
        
        let devicesWithSerial = [];
        if (cadids == null) {
            return [];
        } else {
            devicesWithSerial = uniq(
                map(
                    devices.filter((obj) => cadids.indexOf(obj.customerAssemblyDeviceID) > -1),
                    "deviceWithSerial"
                )
            ).sort();
        }
    }
    static getDeviceFull(devices, mainMachineSerialNo) {
        let deviceFullArray = [];
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].mainMachineSerialNo == mainMachineSerialNo) {
                deviceFullArray.push(devices[i].deviceFull);
            }
        }
        return deviceFullArray;
    }
    static getCadIds(deviceItems) {
        const cadids = [];
        for (let i = 0; i < deviceItems.length; i++) {
            cadids.push(Number(deviceItems[i].id));
        }
        return cadids;
    }
    static GetDeviceItemsByCADIDs(devices, cadids) {
        let deviceItems = [];
        for (let i = 0; i < devices.length; i++) {
            if (cadids.indexOf(devices[i].customerAssemblyDeviceID) > -1) {
                deviceItems.push({
                    text: devices[i].deviceFull,
                    id: devices[i].customerAssemblyDeviceID,
                });
            }
        }
        return deviceItems;
    }
    static GetCustomerByCustomerID(devices, customerID) {
        if (customerID == null) return null;
        const customer = uniq(
            map(
                devices.filter((obj) => obj.customerID === customerID),
                "customerName"
            )
        );
        if (customer.length == 1) {
            return customer[0];
        }
        return null;
    }
    static Assemblys(devices, country, customer) {
        if (country == null && customer == null)
            return uniq(map(devices, "mainMachineSerialNo")).sort();
        if (customer == null) {
            return uniq(
                map(
                    devices.filter((obj) => obj.country === country),
                    "mainMachineSerialNo"
                )
            ).sort();
        } else if (country == null) {
            return uniq(
                map(
                    devices.filter((obj) => obj.customerName === customer),
                    "mainMachineSerialNo"
                )
            ).sort();
        } else {
            return uniq(
                map(
                    devices.filter(
                        (obj) => obj.customerName === customer && obj.country == country
                    ),
                    "mainMachineSerialNo"
                )
            ).sort();
        }
    }
}

export default Format;
